import React from 'react';

function ChosenPassengerAction({ icon, text, handleClick = () => {} }) {
  return (
    <button
      type="button"
      className="flex flex-[1] items-center justify-center p-4 lg:flex-none gap-2 font-base cursor-pointer border-[1px] border-solid rounded-lg border-[#D6D6D6] lg:border-0 bg-transparent"
      onClick={handleClick}
    >
      {icon}
      {text}
    </button>
  );
}

export default ChosenPassengerAction;
